module.exports = __webpack_public_path__ + "img/3-9.6ab66bbd.svg";